import { render, staticRenderFns } from "./TradeList.vue?vue&type=template&id=053f046b&scoped=true"
import script from "./TradeList.vue?vue&type=script&lang=js"
export * from "./TradeList.vue?vue&type=script&lang=js"
import style0 from "./TradeList.vue?vue&type=style&index=0&id=053f046b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053f046b",
  null
  
)

export default component.exports